/** Feature flags — centralised toggles for enabling / disabling features. */

export const DASHBOARD_ON_CHAT = false;
export const SUGGESTIONS_ON_CHAT = false;
export const DATA_SYNCING_ON_HOME = false;
export const DATA_GRAPH_ON_NAV = false;
